import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { promptsAtom } from '@/stores/settingsStore';
import { ListSection } from './ListSection';

export function PromptList() {
  const prompts = useAtomValue(promptsAtom);

  const { systemPrompts, userPrompts } = useMemo(() => {
    const systemPrompts = prompts.filter(p => p.role === 'system');
    const userPrompts = prompts.filter(p => p.role === 'user');
    return { systemPrompts, userPrompts };
  }, [prompts]);

  return (
    <div className='space-y-6'>
      <ListSection title='System prompts' items={systemPrompts} />
      <ListSection title='User prompts' items={userPrompts} />
    </div>
  );
}
